export default __webpack_public_path__ + "static/media/F6.b19f79e4.png";